<template>
<v-snackbar
      :multi-line="true"
      :timeout='snackbarTimeout'
      :success="snackbarStatus === 'success'"
      :info="snackbarStatus === 'info'"
      :warning="snackbarStatus === 'warning'"
      :error="snackbarStatus === 'error'"
      :primary="snackbarStatus === 'primary'"
      :secondary="snackbarStatus === 'secondary'"
      v-model="snackbarVisible"
    >
      {{ message }}
      <v-btn
        flat class="pink--text"
        @click.native="snackbarVisible = false">Close</v-btn>
    </v-snackbar>
</template>
<script>
/* global PubNub */

/*
let examplePayload = {
  'actualChannel': null,
  'subscribedChannel': 'practitioner',
  'timetoken': '14776390256879694',
  'message': {
    'id': 1,
    'mutation': 'schedule.models.AppointmentProcess',
    'process': [{
      'id': 1,
      'name': 'schedule.models.AppointmentProcess',
      'status': 'N',
      'created_date': '2016-10-28T07:17:04.612987Z',
      'modified_date': '2016-10-28T07:17:04.613016Z',
      'request_data': '{}',
      'data': {},
      'appointment': 1
    }],
    'start_time': '2016-10-28T06:00:00Z',
    'end_time': '2016-10-28T07:00:00Z',
    'currency': 'ZAR',
    'price': '0.00',
    'day': 28,
    'month': 10,
    'year': 2016,
    'title': null,
    'full_name': 'Jill User',
    'contact_phone': '+27841102451',
    'contact_email': 'ashley89@jones-johnson.com',
    'notes': null,
    'status': 'N',
    'paid_in_full': false,
    'editable_by_client': true,
    'created_date': '2016-10-28T07:17:04.609612Z',
    'modified_date': '2016-10-28T07:17:04.611133Z',
    'data': {},
    'create_process': true,
    'practitioner': 1,
    'client': 2
  }
} */

// $("body").snackbar({content:'<a data-dismiss="snackbar">Dismiss</a><div class="snackbar-text">Simple snackbar '+snackbarText+' with some text and a simple <a href="javascript:void(0)">link</a>.</div>',show:function()
import moment from 'moment'
import findIndex from 'lodash/findIndex'
import {
  LIST_APPOINTMENTS_IN_RANGE_REQ,
  LIST_INVOICES_IN_RANGE_REQ
} from '@/store/constants'
import RequestMixin from '@/mixins/requests'

const NETWORK_OFFLINE_MESSAGE = 'You are no longer connected to the internet.'
const NETWORK_RECONNECTED_MESSAGE = '\\o/ We\'re back online!'
// const NETWORK_COMPROMIZED_MESSAGE = 'We\'re experiencing intermittent network issues. Please check your network connection'

const DEFAULT_TIMEOUT = 6000

export default {
  findIndex,
  moment,
  mixins: [RequestMixin],
  data () {
    return {
      pubnub: null,
      snackbarVisible: false,
      message: '',
      snackbarTimeout: 6000,
      snackbarStatus: 'secondary'
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    },
    channel () {
      return this.$store.getters.me.channel
    },
    globalNotification () {
      return this.$store.state.application.notification
    },
    activeDateRange () {
      let fromDate = this.$store.state.application.activeDateRange.from
      let toDate = this.$store.state.application.activeDateRange.to
      let result = `${fromDate} to ${toDate}`
      return result
    }
  },
  watch: {
    channel () {
      if (this.channel) {
        this.pubSubInit()
      }
    },
    globalNotification () {
      this.snackbar(
        this.globalNotification.message,
        DEFAULT_TIMEOUT,
        this.globalNotification.type
      )
    },
    activeDateRange () {
      this.getAppointmentsInRange()
    },
    token () {
      if (!this.token) {
        if (this.pubnub) {
          this.pubnub.unsubscribeAll()
          console.log('unsubscribed')
        }
      }
    }
  },
  methods: {
    /* eslint-disable camelcase */
    performMutation ({mutation, data, mutation_type}) {
      console.log(mutation_type, mutation, data)
      if (mutation_type === 'MUTATION') {
        this.$store.commit(mutation, data)
      }
      if (mutation_type === 'ACTION') {
        this.$store.dispatch(mutation, data)
      }
      // if (mutation_type && mutation_type === 'ACTION') {
      //   this.$store.dispatch(mutation, data)
      // } else {
      //   this.$store.commit(mutation, data)
      // }
    },
    getMessage (appointment) {
      let friendlyDate = moment(appointment.start_time).format('HH:mm on ddd D MMM')
      let appointmentString = `${appointment.full_name} at ${friendlyDate}`
      let messageMap = {
        'schedule.models.AppointmentProcess':
        `New appointment: ${appointmentString}`,

        'schedule.models.AppointmentProcess.reschedule':
        `${appointment.full_name} rescheduled to ${friendlyDate}`,

        'schedule.models.AppointmentProcess.cancel':
        `Appointment cancelled: ${appointmentString}`,

        'schedule.models.AppointmentProcess.updateStatus':
        `${appointment.full_name} updated`,

        'schedule.models.AppointmentProcess.requestPayment':
        `Payment request sent for ${appointmentString}`,

        'schedule.models.AppointmentProcess.paymentReceived':
        `${appointmentString} marked as paid`
      }
      if (appointment && appointment.start_time) {
        this.$store.commit('addAppointments', [appointment])
      }

      // handle non-appointment messages:
      if (appointment.type === 'asyncmessage') {
        return appointment.message
      }
      return messageMap[appointment.mutation]
    },
    payloadReceived (payload) {
      let isMutation = (payload.message && payload.message.mutation && payload.message.mutation_type)
      if (isMutation) {
        return this.performMutation(payload.message)
      }
      let appointment = payload.message
      // let date = moment(appointment.start_time).format('YYYY-MM-DD')
      let message = this.getMessage(appointment)
      if (message) {
        this.snackbar(message)
      }
      // todo: delegate to worker
      this.$store.dispatch('RETRY', LIST_APPOINTMENTS_IN_RANGE_REQ)
      // this.getAppointmentsInRange()
    },
    pubSubInit () {
      let vm = this
      vm.networkOfflineNotification = null
      vm.networkCompromizedNotification = null

      let pubnub = new PubNub({
        publishKey: 'pub-c-f303e204-ee0c-4b74-8dd0-436d4a833af7',
        subscribeKey: 'sub-c-ce333652-65fa-11e6-9be8-0619f8945a4f'
      })
      vm.pubnub = pubnub
      pubnub.addListener({
        status: function (statusEvent) {
          /*
PNNetworkUpCategory: SDK detected that network is online.
PNNetworkDownCategory: SDK detected that network is down.
PNNetworkIssuesCategory: A subscribe event experienced an exception when running.
PNReconnectedCategory: SDK was able to reconnect to pubnub.
PNConnectedCategory: SDK subscribed with a new mix of channels (fired every time the channel / channel group mix changed).
PNAccessDeniedCategory: PAM permission failure.
PNMalformedResponseCategory: JSON parsing crashed.
PNBadRequestCategory: Server rejected the request.
PNDecryptionErrorCategory: If using decryption strategies and the decryption fails.
PNTimeoutCategory: Failure to establish connection due to timeout.
           */
          // let networkCompromisedStatus = ['PNNetworkIssuesCategory', 'PNBadRequestCategory', 'PNTimeoutCategory']
          let networkOfflineStatus = ['PNNetworkDownCategory', 'PNAccessDeniedCategory']
          let networkReconnectedStatus = ['PNReconnectedCategory', 'PNNetworkUpCategory']

          console.log(statusEvent.category)
          if (statusEvent.category === 'PNConnectedCategory') {
            // console.log('listening on channel: ' + vm.channel)
            console.log('realtime connected')
          }
          let networkIsOffline = networkOfflineStatus.indexOf(statusEvent.category) !== -1
          // let networkIsCompromised = networkCompromisedStatus.indexOf(statusEvent.category) !== -1
          let networkReconnected = networkReconnectedStatus.indexOf(statusEvent.category) !== -1

          if (networkIsOffline) {
            vm.snackbar(NETWORK_OFFLINE_MESSAGE, 0, 'error')
          }
          // if (networkIsCompromised) {
          //   vm.snackbar(NETWORK_COMPROMIZED_MESSAGE, 0, 'warning')
          // }
          if (networkReconnected) {
            console.log('reconnected')
            vm.snackbar(NETWORK_RECONNECTED_MESSAGE, 6000, 'success')
          }
        },
        message: function (message) {
          // console.log(message.message.type)
          console.log(message)
          let isWarningMessage = (message.subscribedChannel.indexOf('warnings') !== -1)
          if (isWarningMessage) {
            vm.snackbar(message.message.title)
          } else {
            if (message.message.type === 'invoices') {
              vm.getAppointmentsInRange()
              return vm.$store.dispatch(
                'RETRY',
                LIST_INVOICES_IN_RANGE_REQ
              )
            }
            if (message.message.type === 'asyncmessage') {
              vm.$store.commit('addAsyncMessage', message.message)
            }
            let isCommunication = message.message.communicationstatus
            if (isCommunication) {
              vm.$store.commit('addCommunication', message.message)
              // console.log('communication updates', message.message.status)
              return true
            }
            vm.payloadReceived(message)
          }
        },
        presence: function (presenceEvent) {
          console.log(presenceEvent)
        },
        signal: function (s) {
          // handle signal
          if (s.message.rpc && s.message.args) {
            vm[s.message.rpc](s.message.args)
          } else {
            vm[s.message.rpc]()
          }
        }
      })
      // console.log(vm.channel)
      pubnub.subscribe({
        channels: [vm.channel, vm.channel + '-warnings']
      })
    },
    snackbar (message, timeout = 6000, status = 'secondary') {
      this.snackbarVisible = false
      this.message = message
      this.snackbarTimeout = timeout
      this.snackbarStatus = status
      this.snackbarVisible = true
      // $('body').snackbar({ content: message })
    }
  }
}
</script>



// WEBPACK FOOTER //
// RealTimeBeacon.vue?f3e51310